import * as ng from 'angular';

import {
    PanelHeaderData
} from '../../../atomic-components/molecules/panels/panel-header/panel-header';

export class TemplateRedirectionOverviewController {
    public static $inject: string[] = ['$translate'];

    public expertView: boolean;
    public overviewServiceData;
    public overviewModel;
    public pageHeaderData: PanelHeaderData = {
        backwardLink: 'domain.dashboard',
        backwardText: this.$translate.instant('TR_110119-774118_TR'),
        panelHeaderRoute: '',
        panelHeaderRouteParams: {},
        panelIcon: 'globe',
        panelTitle: this.$translate.instant('MENU.CONTEXT.DOMAIN.REDIRECTIONS')
    };
    private simpleFilter;
    private extendedFilters;
    private overviewUiSettings;

    constructor(private $translate: ng.translate.ITranslateService) {}

    public $onInit() {
        if ([undefined, null].indexOf(this.simpleFilter) === -1) {
            this.expertView = this.overviewUiSettings.expertView || this.simpleFilter.show;
        } else {
            this.expertView = this.overviewUiSettings.expertView || false;
        }
        this.overviewServiceData = {
            extendedFilters: this.extendedFilters,
            fancyFilterExpand: this.expertView,
            overviewUiSettings: this.overviewUiSettings,
            simpleFilter: this.simpleFilter
        };
    }

    public expandWrapper = (toggle: { expand: boolean }) => {
        this.expertView = toggle.expand;
    };
}

export class TemplateRedirectionOverviewComponent implements ng.IComponentOptions {
    public bindings = {
        extendedFilters: '<',
        overviewModel: '<',
        overviewUiSettings: '<',
        simpleFilter: '<'
    };
    public template = require('./redirection-overview-template.html');
    public controller = TemplateRedirectionOverviewController;
}
